import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { authenticateGuard, notAuthenticatedGuard } from '@app/shared'
import { ConfirmEmailComponent } from './pages/confirm-email/confirm-email.component'
import { LoginComponent } from './pages/login/login.component'
import { LogoutComponent } from './pages/logout/logout.component'
import { LostPasswordComponent } from './pages/lost-password/lost-password.component'
import { RegisterComponent } from './pages/register/register.component'
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component'

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [notAuthenticatedGuard],
  },
  {
    path: 'logout',
    component: LogoutComponent,
    canActivate: [authenticateGuard],
  },
  {
    path: 'lostpassword',
    component: LostPasswordComponent,
    canActivate: [notAuthenticatedGuard],
  },
  {
    path: 'resetpassword',
    component: ResetPasswordComponent,
    canActivate: [notAuthenticatedGuard],
  },
  {
    path: 'confirmemail',
    component: ConfirmEmailComponent,
    canActivate: [notAuthenticatedGuard],
  },
  {
    path: 'register',
    component: RegisterComponent,
    canActivate: [notAuthenticatedGuard],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SessionRoutingModule {}
